import styled from 'styled-components';

export const _NumberWrapper = styled.div`
  input {
    border-color: rgb(29, 29, 27);
    border-left: 0;
    border-top: 1px solid;
    border-right: 0;
    border-bottom: 1px solid;
    border-radius: 0;
    box-sizing: border-box;
    color: rgb(29, 29, 27);
    font-size: 1em;
    font-weight: 500;
    padding: 22px 12px;
    margin-bottom: 16px;
    width: 150px;
    height: 50px;
    text-align: center;

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type='number'] {
      appearance: textfield;
      -moz-appearance: textfield;
    }

    &:focus {
      border-color: ${(props) => props.theme.black};
      box-shadow: inset 0 0 3px #1b5f4b;
      background-color: ${(props) => props.theme.lightGray};
    }

    &.error {
      border-color: red;
      box-shadow: inset 0 0 3px red;
    }
  }

  div {
    display: flex;

    button {
      height: 50px;
      width: 50px;
      border-radius: 0;
      border: 1px solid;
      padding: 0;
      color: ${(props) => props.theme.primary};
      font-family: ${(props) => props.theme.fontFamilyPrimary};
      font-size: 24px;
      font-weight: 700;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-transform: ${(props) => props.theme.headingTransform};
      background-color: ${(props) => props.theme.white};
      cursor: pointer;
      text-align: center;

      &:nth-of-type(1) {
        border-right: 0;
      }

      &:nth-of-type(2) {
        border-left: 0;
      }

      &:hover {
        background-color: ${(props) => props.theme.hoverPrimary};
        color: ${(props) => props.theme.white};
        border: 1px solid;
        border-color: ${(props) => props.theme.hoverPrimary};
      }

      &:disabled {
        color: ${(props) => props.theme.grey};
        cursor: default;

        &:hover {
          color: ${(props) => props.theme.white};
          background-color: ${(props) => props.theme.grey};
          border-color: ${(props) => props.theme.grey};
        }
      }
    }
  }
`;
